import * as originPackageTransportationService from "../../services/originPackageTransportation";
import * as settings from "../../services/settings";

import { Button, Col, Input, Row, Space, Spin, Table, notification } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

import ModalAddPackageToContainer from "./model/ModalAddPackageToContainer";
import { ModalDelete } from "../model/modal/delete";
import dayjs from "dayjs";
import permissions from "../../../configs/permission";
import { usePermission } from "../../hooks/usePermission";

const initPage = { limit: 10, page: 1 };
export const CreateOriginTransportationPackage = ({
  accessToken,
  isDisabled,
  loading,
  originTransportation,
  t,
  data,
}) => {
  const { hasPermission, isSuperuser } = usePermission();
  const [isOpenModal, setIsModalOpen] = useState(false);
  const [isEdit] = useState(false);
  const [isLoading, setLoading] = useState(loading);
  const [originPackageTransportation, setOriginPackageTransportation] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const [pageOt, setPage] = useState(1);
  const [originPackage, setOriginPackage] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});
  const [search, setSearch] = useState(initPage);
  const [total, setTotal] = useState(0);
  const [route, setRoute] = useState("");
  const [originId, setOriginId] = useState("");
  const [referenceInput, setReferenceInput] = useState("");
  const [appliedReference, setAppliedReference] = useState("");

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const columns = [
    {
      title: t("Origin_Package_Transportation_Create.Create_Package.Table_No"),
      width: "100px",
      dataIndex: "id",
    },
    {
      title: t("Origin_Package_Transportation_Create.Create_Package.Table_Origin_Package"),
      width: "150px",
      dataIndex: "reference",
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Company")}`,
      width: "150px",
      dataIndex: "app_sale", // Adjust this based on your data structure
      render: (_, record) => {
        const app_company = record.app_originpackage?.app_company;
        const company_name = app_company ? app_company.company_name + "(" + app_company.company_code + ")" : "-";
        return <p>{company_name}</p>;
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Sale")}`,
      width: "150px",
      dataIndex: "app_sale", // Adjust this based on your data structure
      render: (_, record) => {
        const origin_package = record.app_originpackage;
        const app_company = origin_package?.app_company;
        const app_sale = origin_package?.app_sale;
        const sale_name = app_sale
          ? app_sale.sale_name + "(" + app_company.company_code + "-" + app_sale.sale_code + ")"
          : "-";
        return <p>{sale_name}</p>;
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Customer")}`,
      width: "150px",
      dataIndex: "app_customer", // Adjust this based on your data structure
      render: (_, record) => {
        const origin_package = record.app_originpackage;
        const app_company = origin_package?.app_company;
        const app_sale = origin_package?.app_sale;
        const app_customer = origin_package?.app_customer;
        const customer = app_customer
          ? app_company?.company_code + "-" + app_sale?.sale_code + app_customer.customer_code
          : "-";

        return <p>{customer}</p>;
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Type")}`,
      width: "100px",
      dataIndex: "package_type", // Adjust this based on your data structure
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Total_Received")}`,
      width: "150px",
      dataIndex: "total_received", // Adjust this based on your data structure
      render: (_, record) => {
        const total_received = record.app_originpackage?.total_received || "-";
        return <p>{total_received}</p>;
      },
    },
    // {
    //   title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Total_Sent")}`,
    //   width: "150px",
    //   dataIndex: "total_sent", // Adjust this based on your data structure
    //   render: (value) => value || "-",
    // },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Total_Count")}`,
      width: "150px",
      dataIndex: "total_count", // Adjust this based on your data structure
      render: (_, record) => record.app_originpackage?.total_count || "-",
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Total_Volume")}`,
      dataIndex: "total_volume", // Adjust this based on your data structure
      width: "150px",
      render: (_, record) => record.app_originpackage?.total_volume || 0.0,
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Total_Weight")}`,
      dataIndex: "total_weight", // Adjust this based on your data structure
      width: "150px",
      render: (_, record) => record.app_originpackage?.total_weight || 0.0,
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Transportation_Status")}`,
      width: "150px",
      dataIndex: "transportation_status", // Adjust this based on your data structure
      render: (_, record) => record.app_origintransportation?.transportation_status || "-",
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Package_Service")}`,
      width: "150px",
      dataIndex: "package_service", // Adjust this based on your data structure
      render: (_, record) => {
        const services = record.app_originpackage?.app_originpackageservice || [];
        if (services.length === 0) return "-";

        const order = ["OD", "WC", "IN"];

        const filtered = services
          .filter((el) => Number(el.service_cost) > 0)
          .sort((a, b) => order.indexOf(a.package_service) - order.indexOf(b.package_service))
          .map((el) => el.package_service);

        return filtered.length > 0 ? filtered.join(", ") : "-";
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Company_Cost")}`,
      width: "150px",
      dataIndex: "company_cost",
      render: (_, record) => record.company_cost || 0,
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Apply_Company_Weight_Formula")}`,
      width: "200px",
      dataIndex: "apply_company_weight_formula",
      render: (_, record) => record.apply_company_weight_formula || "-",
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Company_Weight_Formula")}`,
      width: "200px",
      dataIndex: "company_weight_formula",
      render: (_, record) => {
        const app_company_weight_formula = record.app_companyweightformula;
        const formula = app_company_weight_formula
          ? "[" +
            app_company_weight_formula.route +
            "]" +
            app_company_weight_formula.weight_from +
            "-" +
            app_company_weight_formula.weight_to +
            "=" +
            app_company_weight_formula.a +
            "/" +
            app_company_weight_formula.b +
            "/" +
            app_company_weight_formula.c +
            "/" +
            app_company_weight_formula.d
          : "-";
        return <p>{formula}</p>;
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Apply_Company_Volume_Formula")}`,
      width: "200px",
      dataIndex: "apply_company_volume_formula",
      render: (_, record) => record.apply_company_volume_formula || "-",
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Company_Volume_Formula")}`,
      width: "200px",
      dataIndex: "company_volume_formula",
      render: (_, record) => {
        const app_company_volume_formula = record.app_companyvolumeformula;
        const company_volume_formula = app_company_volume_formula
          ? "[" +
            app_company_volume_formula.route +
            "]" +
            app_company_volume_formula.volume_from +
            "-" +
            app_company_volume_formula.volume_to +
            "=" +
            app_company_volume_formula.a +
            "/" +
            app_company_volume_formula.b +
            "/" +
            app_company_volume_formula.c +
            "/" +
            app_company_volume_formula.d
          : "-";
        return <p>{company_volume_formula}</p>;
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Is_Company_Weight_Formula")}`,
      width: "200px",
      dataIndex: "is_company_weight_formula", // Adjust this based on your data structure
      render: (_, record) => {
        if (record.is_company_weight_formula) {
          return (
            <p style={{ color: "green" }}>
              <CheckCircleOutlined />
            </p>
          );
        } else {
          return (
            <p style={{ color: "red" }}>
              <CloseCircleOutlined />
            </p>
          );
        }
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Company_Bill")}`,
      width: "150px",
      dataIndex: "app_companybillitem", // Adjust this based on your data structure
      render: (_, record) => {
        const app_companybillitem = record.app_companybillitem;
        if (app_companybillitem && app_companybillitem.length > 0) {
          const companybill = app_companybillitem.at(0);
          return <p>{companybill.id + " " + companybill.bill_amount}</p>;
        } else {
          return <p>{"-"}</p>;
        }
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Customer_Cost")}`,
      width: "150px",
      dataIndex: "customer_cost", // Adjust this based on your data structure
      render: (_, record) => record.company_cost || 0,
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Apply_Customer_Weight_Formula")}`,
      width: "150px",
      dataIndex: "apply_customer_weight_formula", // Adjust this based on your data structure
      render: (value) => value || "-",
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Customer_Weight_Formula")}`,
      width: "200px",
      dataIndex: "customer_weight_formula",
      render: (_, record) => {
        const formala = record.app_customerweightformula;
        const customer_weight_formula = formala
          ? "[" +
            (formala.route ?? "") +
            "]" +
            (formala.weight_from ?? 0) +
            "-" +
            (formala.weight_to ?? 0) +
            "=" +
            (formala.a ?? 0) +
            "/" +
            (formala.b ?? 0) +
            "/" +
            (formala.c ?? 0) +
            "/" +
            (formala.d ?? 0)
          : "-";
        return <p>{customer_weight_formula}</p>;
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Apply_Customer_Volume_Formula")}`,
      width: "150px",
      dataIndex: "apply_customer_volume_formula", // Adjust this based on your data structure
      render: (value) => value || "-",
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Customer_Volume_Formula")}`,
      width: "200px",
      dataIndex: "customer_volume_formula",
      render: (_, record) => {
        const formala = record.app_customervolumeformula;
        const customer_volume_formula = formala
          ? "[" +
            (formala.route ?? "") +
            "]" +
            (formala.weight_from ?? 0) +
            "-" +
            (formala.weight_to ?? 0) +
            "=" +
            (formala.a ?? 0) +
            "/" +
            (formala.b ?? 0) +
            "/" +
            (formala.c ?? 0) +
            "/" +
            (formala.d ?? 0)
          : "-";
        return <p>{customer_volume_formula}</p>;
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Is_Customer_Weight_Formula")}`,
      width: "150px",
      dataIndex: "is_customer_weight_formula", // Adjust this based on your data structure
      render: (_, record) => {
        if (record.is_customer_weight_formula) {
          return (
            <p style={{ color: "green" }}>
              <CheckCircleOutlined />
            </p>
          );
        } else {
          return (
            <p style={{ color: "red" }}>
              <CloseCircleOutlined />
            </p>
          );
        }
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Customer_Bill")}`,
      width: "150px",
      dataIndex: "customer_bill_item", // Adjust this based on your data structure
      render: (_, record) => {
        const app_customerbillitem = record.app_customerbillitem;
        if (app_customerbillitem && app_customerbillitem.length > 0) {
          const customerbill = app_customerbillitem.at(0);
          return <p>{customerbill.id + " " + customerbill.bill_amount}</p>;
        } else {
          return <p>{"-"}</p>;
        }
      },
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Density")}`,
      width: "150px",
      dataIndex: "density", // Adjust this based on your data structure
    },
    {
      title: `${t("Origin_Package_Transportation_Create.Create_Package.Table_Unpaid_Bill_Amount")}`,
      width: "150px",
      dataIndex: "unpaid_bill_amount",
      render: (_, record) => {
        const checkUnpaidStatus = (billItems, key) => {
          const bill = billItems?.[0];
          const status = bill?.[key]?.bill_status?.toLowerCase();
          return status === "unpaid" ? bill.bill_amount : "-";
        };

        const { app_customerbillitem, app_companybillitem } = record;

        return (
          <p>
            {app_customerbillitem?.length
              ? checkUnpaidStatus(app_customerbillitem, "app_customerbill")
              : app_companybillitem?.length
                ? checkUnpaidStatus(app_companybillitem, "app_companybill")
                : "-"}
          </p>
        );
      },
    },
    {
      title: `${t("Create_At", { ns: "common" })}`,
      width: "150px",
      dataIndex: "created_at", // Adjust this based on your data structure
      render: (_, record) => {
        const created_at = record.created_at != null ? dayjs(record.created_at).format("YYYY-MM-DD hh:mm:ss A") : "-";
        return <p>{created_at}</p>;
      },
    },
    {
      title: `${t("Update_At", { ns: "common" })}`,
      width: "150px",
      dataIndex: "updated_at", // Adjust this based on your data structure
      render: (_, record) => {
        const updated_at = record.updated_at != null ? dayjs(record.updated_at).format("YYYY-MM-DD hh:mm:ss A") : "-";
        return <p>{updated_at}</p>;
      },
    },
    {
      title: `${t("Delete", { ns: "common" })}`,
      width: "150px",
      key: "delete",
      render: (_, record) => (
        <Button
          disabled={!hasPermission(permissions.OriginPackageTransportation.DELETE)}
          onClick={() => {
            setIsOpenDelete(true);
            setPrepareDeleteData(record);
          }}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  const deleteOriginPackageTransportation = async (data) => {
    let prepareData = {
      id: data.id,
    };
    setLoading(true);
    try {
      const response = await originPackageTransportationService.deleteOriginPackageTransportation(
        accessToken,
        prepareData
      );
      if (response == undefined) {
        openNotificationWithIcon(
          settings.NotificationType.ERROR,
          <>{"Fail."}</>,
          <>{"Delete error, Please check service"}</>
        );
      } else {
        openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Delete Success"}</>);
        setPrepareDeleteData({});
        setIsOpenDelete(false);
        fetchOriginPackageTransportationData();
        setLoading(false);
      }
    } catch (err) {
      console.error("[CreateOriginTransportationPackage] deleteOriginPackageTransportation: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const handleOnOpenModal = () => {
    setIsModalOpen(true);
  };

  //
  const getListPackages = async (pageOt, searchData) => {
    const params = { page: pageOt, limit: 20, reference: searchData };
    try {
      const data = await originPackageTransportationService.getOriginPackage(accessToken, params);
      let resOriginPackage = [];
      data.queryOriginPackageList.map((value) => {
        resOriginPackage.push({
          value: value.id,
          label: value.reference,
        });
      });
      // let valueDestinationPackage = resOriginPackage.filter( (oldValue, index) => index === resDestinationPackage.findIndex( data => data.value === oldValue.value))
      setOriginPackage((prevOptions) => [...prevOptions, ...resOriginPackage]);
      setPage(pageOt);
    } catch (err) {
      console.error("[CreateOriginTransportationPackage] getListPackages: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
    }
  };

  const fetchOriginPackageTransportationData = async (value, referenceOverride) => {
    setLoading(true);
    try {
      initPage.limit = value !== undefined && value.limit ? value.limit : initPage.limit;
      initPage.page = value !== undefined && value.page ? value.page : initPage.page;

      const referenceToUse = referenceOverride !== undefined ? referenceOverride : appliedReference;

      const params = {
        transportation_id: originTransportation.id,
        page: initPage.page,
        limit: initPage.limit,
        reference: referenceToUse,
      };

      const response = await originPackageTransportationService.searchOriginPackageTransportation(accessToken, params);
      if (response !== null || response != undefined) {
        setLoading(false);
        setTotal(response.totalCount);
        setOriginPackageTransportation(response.data);
        setSearch({ page: initPage.page, limit: initPage.limit });
        setRoute(originTransportation.route);
        setOriginId(originTransportation.origin_id);
      }
    } catch (err) {
      console.error("[CreateOriginTransportationPackage] fetchOriginPackageTransportationData: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const handleSearchReference = () => {
    const next = (referenceInput || "").trim();
    setAppliedReference(next);
    fetchOriginPackageTransportationData({ page: 1, limit: search.limit }, next);
  };

  const handleResetReference = () => {
    setReferenceInput("");
    setAppliedReference("");
    fetchOriginPackageTransportationData({ page: 1, limit: search.limit }, "");
  };

  useEffect(() => {
    if (originTransportation != undefined) {
      fetchOriginPackageTransportationData(search);
      setRoute(originTransportation.route);
      setOriginId(originTransportation.origin_id);
    }
    getListPackages(pageOt);
  }, [originTransportation]);

  return (
    <>
      {contextHolder}
      <Spin spinning={isLoading}>
        <Row align="middle" justify="end" style={{ marginBottom: "10px" }}>
          <Col span={24}>
            {`${t("Origin_Package_Transportation_Create.Create_Package.Search.Reference")}: `}
            <Space wrap>
              <Input
                allowClear
                placeholder={t("Origin_Package_Transportation_Create.Create_Package.Search.Reference_Placeholder")}
                value={referenceInput}
                maxLength={64}
                onChange={(e) => setReferenceInput(e.target.value)}
                onPressEnter={handleSearchReference}
                style={{ width: 240 }}
              />
              <Button type="primary" icon={<SearchOutlined />} onClick={handleSearchReference}>
                {t("Button_Origin_Package_Transportation.BTN_Search")}
              </Button>
              {appliedReference ? (
                <Button onClick={handleResetReference}>{t("Button_Origin_Package_Transportation.BTN_Reset")}</Button>
              ) : null}
            </Space>
          </Col>
        </Row>
        <Row align="middle" justify="end">
          <Col span={24}>
            <Table
              dataSource={originPackageTransportation}
              columns={columns}
              scroll={{ x: "1440px", y: "500px" }}
              rowKey={(record) => record.id}
              style={{ cursor: "pointer" }}
              pagination={{
                defaultPageSize: search.limit,
                current: search.page,
                pageSize: search.limit,
                total: total,
                onChange: (page, limit) => {
                  fetchOriginPackageTransportationData({ page, limit });
                },
                showSizeChanger: true,
              }}
              rowClassName={(record) => {
                return record?.after_closed ? "row-closed" : "";
              }}
            />
          </Col>
          {(data?.type === "CREATE" && hasPermission(permissions.OriginPackageTransportation.ADD)) ||
          (data?.type === "EDIT" && hasPermission(permissions.OriginPackageTransportation.CHANGE)) ? (
            <Row justify="end" style={{ marginTop: "10px" }}>
              <Col span={24}>
                <Button
                  disabled={isDisabled}
                  type="primary"
                  onClick={handleOnOpenModal}
                  style={{ marginRight: "10px", justifyContent: "end" }}
                >
                  {t("Button_Origin_Package_Transportation.BTN_Add_Package")}
                </Button>
              </Col>
            </Row>
          ) : undefined}
          <ModalAddPackageToContainer
            open={isOpenModal}
            setOpen={setIsModalOpen}
            data={originTransportation}
            fetchOriginPackageTransportationData={fetchOriginPackageTransportationData}
            route={route}
            originId={originId}
          />
        </Row>
        <ModalDelete
          isOpen={isOpenDelete}
          handleCloseModal={() => {
            setIsOpenDelete(false);
          }}
          onClick={() => {
            deleteOriginPackageTransportation(prepareDeleteData);
          }}
          dataDetail={prepareDeleteData}
          t={t}
        />
      </Spin>
    </>
  );
};
